import { createElement } from "react";

import type { CellContext, RowData } from "@tanstack/react-table-v9";

import { colorTheme } from "@utils";

import type { TableV2Features } from "./features";
import { formatCellValue, isNegativeValue } from "./formatters";

/** Default `cell` for every column: formats by `meta.type` and shows `meta.fallback` for empty values */
export const renderDefaultCell = <TData extends RowData>(
  context: CellContext<TableV2Features, TData, unknown>,
) => {
  const meta = context.column.columnDef.meta;
  const value = context.getValue();
  const text = formatCellValue(value, meta);
  if (text === null) return meta?.fallback ?? "";
  if (meta?.negative?.red && isNegativeValue(value)) {
    return createElement(
      "span",
      { style: { color: colorTheme("danger") } },
      text,
    );
  }
  return text;
};
